import React from 'react';
import TopNavNotifications from './TopNavNotifications';
import StateContainer from '../../notifications/NotificationsStateContainer';

export default StateContainer(TopNavNotifications);
